export default {
  api: {
    operationFailed: "操作失败",
    test: "测试",
  },
  menu: {
    userInfo: "个人信息",
    provider: "数据卖家",
    buyer: "数据买家",
    myOrder: "我的订单",
    myApi: "我的API",
    myReport: "我的报告",
    myMessage: "我的消息",
    setting: "设置",
    about: "关于",
  },
  tableOperate: "操作",
  pay: {
    payType1: "网银支付",
    payType2: "支付宝支付",
    payType3: "微信支付",
  },
  download: {
    publishTip:
      "为了确保您有更便捷和安全的数据发布体验，典枢目前仅支持在客户端发布数据。",
    goDownload: "前去下载",
    openApp: "打开客户端",
    reminder: "提醒",
    importantNotice: "重要提醒",
    downloadTip: "下载数据",
    viewReport: "查看报告",
    downloadTip2:
      "需通过典枢客户端完成，请您打开客户端进行操作。如尚未安装客户端，请先下载并安装以继续操作。感谢您的理解与支持。",
    downloadTip3:
      "需通过典枢客户端完成，请您打开客户端进行操作。如尚未安装客户端，请先下载并安装以继续操作。",
    supportText: "感谢您的理解与支持。",
    downloadApp: "下载客户端",
    installed: "我已安装",
    title: "为了确保您能够更安全、高效地发布数据",
    subtitle: "典枢平台为您提供了专门的客户端",
    downloadButton: "下载客户端",

    securitySection: {
      title: "数据加密，安全无忧",
      description:
        "使用客户端发布数据时，您的数据将在本地进行加密处理，仅在您授权的情况下，数据才会被解密（买家付款后视为您已授权解密）。这一措施确保您的数据在上传之前就已得到保护，有效降低数据泄露的风险。",
    },

    transmissionSection: {
      title: "断点续传，上传不中断",
      description:
        "客户端支持断点续传功能，即便遇到网络波动，也能确保上传进程不受影响，避免因网络中断而需要重新上传。",
    },

    actionButton: "到客户端发布数据",
  },
  platforms: {
    title: "典枢客户端，让数据交易流程更加便捷安全",
    subtitle: "数据发布和数据下载需要在典枢客户端完成",
    learnMore: "了解详情",
    developer: "开发者：北京熠智科技有限公司",
    version: "版本号：",
    updateRecord: "想知道典枢更新过哪些内容？查看",
    versionRecord: "版本更新记录",
    mac: {
      name: "macOS",
      desc1: "支持 macOS 10.13 (High Sierra)及以上版本",
      download: "立即下载",
    },
    windows: {
      name: "Windows",
      desc1: "支持 Windows 10 (1809) 及以上版本",
      download: "立即下载",
    },
    linux: {
      name: "Linux",
      desc1: "支持 Ubuntu 20.04、Fedora 30、\n Debian 10及以上版本",
      download: "立即下载",
    },
  },
};
